/**
 * Pre-launch Stoq adaptation. Runs only when the theme pre-launch setting
 * is on and the current product is in the handle list. Does not submit
 * email, send notifications, or retitle ordinary restock forms.
 */
(function () {
  var cfg = (window.themeVariables && window.themeVariables.prelaunch) || {};
  var copy = cfg.copy || {};
  var BUTTON = copy.button || 'Notify me at launch';
  var HEADING = copy.heading || 'Be first to know';
  var NOTE = copy.body || 'Join the waitlist to hear when this piece launches.';
  var SUCCESS = copy.success || 'You’re on the list. We’ll email you when this piece launches.';
  var SUCCESS_SOURCE = /you're on the list|registration confirmed|next batch|ready to order|product is restocked/i;
  var signupConfirmed = false;

  function handles() {
    return String(cfg.handles || '')
      .toLowerCase()
      .split(/[\s,]+/)
      .map(function (item) { return item.trim(); })
      .filter(Boolean);
  }

  function currentHandle() {
    var picker = document.querySelector('variant-picker');
    var fromPicker = picker && picker.getAttribute('handle');
    return String(fromPicker || cfg.productHandle || '').toLowerCase();
  }

  function isPrelaunchProduct() {
    if (!cfg.enabled) return false;
    if (document.querySelector('.prelaunch-stoq-slot')) return true;
    var handle = currentHandle();
    return !!(handle && handles().indexOf(handle) !== -1);
  }

  function textOf(el) {
    return (el && (el.innerText || el.textContent) || '').replace(/\s+/g, ' ').trim();
  }

  function setText(el, value) {
    if (!el || textOf(el) === value) return;
    if (el.childElementCount === 0) {
      el.textContent = value;
      return;
    }
    var leaf = el.querySelector('span, strong, em, b') || el;
    if (leaf.childElementCount === 0) leaf.textContent = value;
  }

  function stoqRoot(el) {
    return el && el.closest && el.closest('#formContainer, .restock-rocket-wrapper, #restock-rocket, [class*="restock-rocket"]');
  }

  function currentVariantId() {
    var input = document.querySelector('product-form [name="id"], form[action*="/cart/add"] [name="id"]');
    if (input && input.value) return String(input.value);
    try {
      var params = new URLSearchParams(window.location.search);
      if (params.get('variant')) return String(params.get('variant'));
    } catch (err) {}
    return null;
  }

  var selectRetry = null;
  function syncStoqVariant() {
    if (!isPrelaunchProduct()) return;
    var id = currentVariantId();
    if (!id) return;

    var api = window._RestockRocket;
    if (api && typeof api.renderButtonForVariant === 'function') {
      api.renderButtonForVariant(id);
    }

    var attempts = 0;
    if (selectRetry) clearInterval(selectRetry);
    function trySelect() {
      var select = document.getElementById('form-Select');
      if (select && (!stoqRoot(select) || !select.querySelector('option[value="' + id + '"]'))) {
        return false;
      }
      if (select && select.value !== id) {
        select.value = id;
        select.dispatchEvent(new Event('input', { bubbles: true }));
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
      return !!(select && select.value === id);
    }
    trySelect();
    selectRetry = setInterval(function () {
      attempts += 1;
      trySelect();
      if (attempts > 30) {
        clearInterval(selectRetry);
        selectRetry = null;
      }
    }, 80);
  }

  function retitleSuccess() {
    if (!isPrelaunchProduct() || !signupConfirmed) return;
    var nodes = document.querySelectorAll(
      '#form-Success, #form-Success-Text, #form-Success-Message, [id^="form-Success"]'
    );
    nodes.forEach(function (el) {
      if (!stoqRoot(el) && el.id.indexOf('form-Success') !== 0) return;
      var t = textOf(el);
      if (t && SUCCESS_SOURCE.test(t)) setText(el, SUCCESS);
    });

    var wrap = document.querySelector('#formContainer, .restock-rocket-wrapper');
    if (!wrap) return;
    wrap.querySelectorAll('p, div, h2, h3, span').forEach(function (el) {
      if (el.childElementCount > 0) return;
      var t = textOf(el);
      if (t && SUCCESS_SOURCE.test(t)) setText(el, SUCCESS);
    });
  }

  function retitle() {
    if (!isPrelaunchProduct()) return;

    document.querySelectorAll(
      '.prelaunch-stoq-slot .restock-rocket-button-product, .prelaunch-stoq-slot [aria-haspopup="dialog"], .restock-rocket-button-product'
    ).forEach(function (btn) {
      setText(btn, BUTTON);
      if (btn.getAttribute('aria-label')) btn.setAttribute('aria-label', BUTTON);
    });

    var heading = document.getElementById('form-Header-Text');
    if (heading && stoqRoot(heading)) heading.textContent = HEADING;

    var description = document.getElementById('form-Description');
    if (description && stoqRoot(description)) description.textContent = NOTE;

    var submit = document.getElementById('form-Button');
    if (submit && stoqRoot(submit)) submit.textContent = BUTTON;

    retitleSuccess();
  }

  var retitleTimer = null;
  function retitleForAWhile() {
    retitle();
    if (retitleTimer) clearInterval(retitleTimer);
    var ticks = 0;
    retitleTimer = setInterval(function () {
      retitle();
      ticks += 1;
      if (ticks > 30) {
        clearInterval(retitleTimer);
        retitleTimer = null;
      }
    }, 100);
  }

  function relocate() {
    if (!isPrelaunchProduct()) return;
    document.querySelectorAll('.prelaunch-stoq-slot').forEach(function (slot) {
      if (slot.querySelector('[class*="restock-rocket-button-container"]')) return;
      var widget = document.querySelector(
        '.restock-rocket-button-container-float-right, .restock-rocket-button-container-float-left, [class*="restock-rocket-button-container"]'
      );
      if (!widget || slot.contains(widget)) return;
      slot.appendChild(widget);
      widget.style.position = 'static';
      widget.style.transform = 'none';
      widget.style.right = 'auto';
      widget.style.top = 'auto';
      widget.style.width = '100%';
      var btn = widget.querySelector('button, [role="button"]');
      if (btn) {
        btn.style.width = '100%';
        btn.style.transform = 'none';
        btn.style.writingMode = 'horizontal-tb';
      }
      widget.querySelectorAll('.restock-rocket-button-cover').forEach(function (cover) {
        cover.style.display = 'none';
      });
    });
  }

  var scheduled = false;
  var pendingSync = false;
  function apply(opts) {
    if (opts && opts.syncVariant) pendingSync = true;
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      if (!isPrelaunchProduct()) return;
      relocate();
      if (pendingSync) {
        pendingSync = false;
        syncStoqVariant();
      }
      retitle();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { apply({ syncVariant: true }); });
  } else {
    apply({ syncVariant: true });
  }

  window.addEventListener('stoq:loaded', function () { apply({ syncVariant: true }); });
  window.addEventListener('stoq:modal:opened', function () {
    apply({ syncVariant: true });
    retitleForAWhile();
  });
  window.addEventListener('stoq:variant:changed', function () { apply({ syncVariant: true }); });
  window.addEventListener('stoq:intent:created', function () {
    signupConfirmed = true;
    retitleSuccess();
  });

  document.addEventListener('variant:change', function () {
    if (!isPrelaunchProduct()) return;
    apply({ syncVariant: true });
  });
  document.addEventListener('product:rerender', function () { apply({ syncVariant: true }); });
  document.addEventListener('click', function (event) {
    if (!isPrelaunchProduct()) return;
    var trigger = event.target.closest && event.target.closest(
      '.prelaunch-stoq-slot [aria-haspopup="dialog"], .prelaunch-stoq-slot .restock-rocket-button-product, .restock-rocket-button-product, [class*="restock-rocket-button"]'
    );
    if (!trigger) return;
    setTimeout(function () { apply({ syncVariant: true }); }, 50);
    setTimeout(function () { apply({ syncVariant: true }); }, 350);
    retitleForAWhile();
  }, true);

  var observer = new MutationObserver(function (mutations) {
    if (!isPrelaunchProduct()) return;
    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var node = added[j];
        if (node.nodeType !== 1) continue;
        if (
          node.id === 'formContainer' ||
          node.id === 'form-Header-Text' ||
          (node.querySelector && node.querySelector('#formContainer, #form-Header-Text'))
        ) {
          apply({ syncVariant: true });
          retitleForAWhile();
          return;
        }
        if (
          node.id === 'form-Success' ||
          (node.className && String(node.className).indexOf('restock-rocket') !== -1) ||
          (node.querySelector && node.querySelector('#form-Header-Text, #form-Success, [class*="restock-rocket"]'))
        ) {
          apply();
          return;
        }
      }
    }
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });

  var tries = 0;
  var timer = setInterval(function () {
    var slotted = document.querySelector('.prelaunch-stoq-slot [class*="restock-rocket-button-container"]');
    relocate();
    retitle();
    if (!slotted && window._RestockRocket) syncStoqVariant();
    tries += 1;
    if (tries > 48 || slotted) clearInterval(timer);
  }, 250);
})();
